module.exports = __webpack_public_path__ + "img/1.62b97dca.jpg";